var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-folder-layer__item d-flex align-items-center mt-2" },
    [
      _c("div", { staticClass: "c-folder-layer__item--preview mr-2" }, [
        _c("img", {
          staticClass: "layer--item__img",
          attrs: { src: _vm.src, alt: _vm.name },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "tooltip", staticClass: "layer--item__text" },
        [
          _c(
            "b-tooltip",
            {
              attrs: {
                show: _vm.isTooltipShown,
                target: () => _vm.$refs.tooltip,
                triggers: "hover",
                boundary: "viewport",
                noninteractive: "",
                disabled: _vm.isNotTruncated(_vm.name),
              },
              on: {
                "update:show": function ($event) {
                  _vm.isTooltipShown = $event
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]
          ),
          _vm._v(" "),
          _c("EditableTextElement", {
            attrs: {
              "default-value": _vm.name,
              "render-value": _vm.truncateFieldName,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }